import { Radio } from 'lucide-react';
import { useMemo } from 'react';
import { session } from '../lib/session';
import { targetLabel, useStore } from '../store';

export function PeopleList() {
  const users = useStore((s) => s.users);
  const presence = useStore((s) => s.presence);
  const me = useStore((s) => s.user);

  const sorted = useMemo(
    () =>
      [...users].sort((a, b) => {
        const ao = presence[a.id]?.online ? 0 : 1;
        const bo = presence[b.id]?.online ? 0 : 1;
        return ao - bo || a.displayName.localeCompare(b.displayName);
      }),
    [users, presence],
  );

  return (
    <div className="people">
      {sorted.map((u) => {
        const p = presence[u.id];
        const online = !!p?.online;
        return (
          <div key={u.id} className={`person ${online ? '' : 'person--offline'}`} onClick={() => u.id !== me?.id && session.openChat(`user:${u.id}`)} title={online ? p?.client : 'offline'}>
            <span className={`dot ${online ? (p!.talking.length ? 'dot--live' : 'dot--brand') : ''}`} data-sw={u.color} />
            <div>
              <div className="person__name">
                {u.displayName}
                {u.id === me?.id && <span className="muted"> (you)</span>}
              </div>
              <div className="person__meta">
                <span>{u.role === 'admin' ? 'admin' : online ? p?.client : 'offline'}</span>
                {p?.feeding.map((c) => (
                  <span key={c} className="chip chip--brand" style={{ padding: '0 6px' }}>
                    <Radio size={10} /> PGM {targetLabel(`ch:${c}`, true)}
                  </span>
                ))}
              </div>
            </div>
            <div className="person__talk">{p?.talking.map((t) => targetLabel(t, true)).join(' ')}</div>
          </div>
        );
      })}
    </div>
  );
}
